import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import {
  CodeBookPagedFilter,
  SaveResult,
  OibServiceResult,
} from "../../models";
import {
  InstitutionCommittee,
  CommitteeSearch,
  CommitteeStatus,
  CommitteeRole,
  OibEmployee,
} from "../../models/Committee";

const apiUrlPrefix: string = "institution-committees";

export const getInstitutionCommitteeById = async (id: number) => {
  return api.get(
    `${apiUrlPrefix}/get-committee/${id}`
  ) as Promise<InstitutionCommittee>;
};

export const createInstitutionCommitteeById = async (institutionId: number) => {
  return api.get(
    `${apiUrlPrefix}/create-committee/${institutionId}`
  ) as Promise<InstitutionCommittee>;
};

export const searchInstitutionCommittee = async (search: CommitteeSearch) => {
  return api.post(`${apiUrlPrefix}/search-committees`, search) as Promise<
    PagedResult<InstitutionCommittee>
  >;
};

export const getInstitutionCommitteeCommitteeStatusList = async () => {
  return api.get(`${apiUrlPrefix}/statuses-all`) as Promise<CodeBook[]>;
};

export const getInstitutionCommitteeCommitteeRoleList = async () => {
  return api.get(`${apiUrlPrefix}/roles-all`) as Promise<CommitteeRole[]>;
};

export const saveInstitutionCommittee = async (item: InstitutionCommittee) => {
  return api.put(`${apiUrlPrefix}/save-committee`, item) as Promise<
    SaveResult<InstitutionCommittee>
  >;
};

export const searchInstitutionCommitteeEmployee = async (
  search: CodeBookPagedFilter
) => {
  return api.post(`${apiUrlPrefix}/search-employees`, search) as Promise<
    PagedResult<CodeBook>
  >;
};

export const changeInstitutionCommitteeStatus = async (
  id: number,
  status: CommitteeStatus
) => {
  return api.post(`${apiUrlPrefix}/save-status/${id}/${status}`) as Promise<
    SaveResult<InstitutionCommittee>
  >;
};

export const getInstitutionCommitteeEmployeeOib = async (oib: string) => {
  return api.get(`${apiUrlPrefix}/oib/${oib}`) as Promise<
    OibServiceResult<OibEmployee>
  >;
};

export const getInstitutionCommitteeListExport = async (
  search: CommitteeSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/export/${type}`,
    "post",
    search
  ) as Promise<any>;
};
